// src/modules/app-views/products/pages/Init/components/tableColumns/priceColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { DollarOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function priceColumn(buildColumnProps, options = {}) {
  const {
    key = 'price',
    title = 'price',
    dataIndex = ['pricing', 'salePrice'],
    width = 120,
    align = 'right',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps('pricing.salePrice', columnProps),
    render: (_, r) => {
      const price = r?.pricing?.salePrice || r?.price;
      return price ? (
        <span>
          <DollarOutlined style={{ marginRight: 4, color: '#52c41a' }} />
          {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price)}
        </span>
      ) : (
        '—'
      );
    },
  };
}

export default priceColumn;
